module.exports = __webpack_public_path__ + "img/otsar-large.28f319bf.png";